import { Expedition, PriceFamily, PriceType, Product } from "models";
import request from "./requesters/bo.request";
import {
  BoResponse,
  CatalogPriceZoneServiceProvider,
  CatalogPriceZoneServiceProviderRequest,
  ManualProductPrices,
  PaginationData,
  QueryParams,
  ServiceProvider,
  UrbanCenterWithZoneResponse,
} from "types";
import { ProductTarifType } from "utils/constant";

const boService = {
  getQBOExpeditionById: (expeditionId: number, query: QueryParams) =>
    request.get<BoResponse<Expedition>>(
      `/qbo-expedition-by-id/${expeditionId}`,
      {
        params: query,
      }
    ),
  getQBOCatalogPriceZoneServiceProviders: (
    data: CatalogPriceZoneServiceProviderRequest
  ) =>
    request.post<
      BoResponse<{
        products: { id: number; type: ProductTarifType }[];
        serviceProviderCatalogPriceWithPrice: CatalogPriceZoneServiceProvider[];
        manualProductPrices?: ManualProductPrices[];
      }>
    >(`/qbo-catalog-prices-zone-service-provider`, data),
  getQBOZonesByChantierAddress: (latitude: string, longitude: string) =>
    request.get<BoResponse<UrbanCenterWithZoneResponse>>(
      `/qbo-urban-centers-zone`,
      {
        params: { latitude, longitude },
      }
    ),
  getQBOProductsByIds: (params: QueryParams) =>
    request.get<BoResponse<PaginationData<Product>>>(`/qbo-products-by-ids`, {
      params,
    }),
  getQBOProducts: (params: QueryParams) =>
    request.get<BoResponse<PaginationData<Product>>>(`/qbo-products`, {
      params,
    }),
  getQBOServiceProvidersByIds: (params: QueryParams = {}) =>
    request.get<BoResponse<PaginationData<ServiceProvider>>>(
      "/qbo-service-providers-by-ids",
      {
        params: { ...params, serviceType: "benneur" },
      }
    ),
  getQBOPriceFamilies: (params?: QueryParams) =>
    request.get<BoResponse<PriceFamily[]>>(`/qbo-price-families`, { params }),
  getQBOPriceTypes: (params?: QueryParams) =>
    request.get<BoResponse<PriceType[]>>(`/qbo-price-types`, { params }),
  storeNewServiceProvider: (expeditionId: number, data: object) =>
    request.put<BoResponse<ServiceProvider>>(
      `/qbo-store-new-service-provider/${expeditionId}`,
      data
    ),
};

export default boService;
